module.exports = __webpack_public_path__ + "static/img/Home62@2x.1681ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home62@2x.png
// module id = jYEj
// module chunks = 1